import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import type { HotelStayType } from '../types';
import type { SearchControlsOnSubmitParams } from '@shared/hotels-search-controls/types';
import type { Configs } from '@shared/types/configs';
import type { I18nService } from '@shared/types/i18n';
import type { UserContext } from '@shared/types/user-context';

import STYLES from './ExploreOtherOptions.module.scss';

import SearchControls, {
  LAYOUT,
} from '@shared/hotels-search-controls/SearchControls';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { withI18n } from '@shared/ui/contexts/i18n';
import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';
import { withUserContext } from '@shared/utils-frontend/contexts/UserContext';
import { getDayviewUrl } from '@shared/utils-frontend/url/url';

type Props = {
  i18n: I18nService;
  configs: Configs;
  userContext: UserContext;
} & HotelStayType;

const ExploreOtherOptions = ({
  configs,
  destination,
  i18n: { formatDate, translate },
  stay,
  userContext,
}: Props) => {
  const showSearchControls: boolean = !(
    userContext?.enableSEOVariantHotelsDetailsPage &&
    configs?.enableFooterSEOVariant
  );

  const onSubmit = ({
    checkIn,
    checkOut,
    childrenAges,
    destination: destinationParam,
    numberOfAdults,
    numberOfRooms,
  }: SearchControlsOnSubmitParams) => {
    const stayParam = {
      checkIn,
      checkOut,
      numberOfAdults,
      numberOfRooms,
      childrenAges,
    };

    const dayview = getDayviewUrl(
      {
        destination: destinationParam,
        stay: stayParam,
      },
      formatDate,
    );
    window.open(dayview, '_blank');
  };

  return (
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile: boolean) => (
        <div className={STYLES.ExploreOtherOptions}>
          {showSearchControls ? (
            <div className={STYLES.ExploreOtherOptions__search}>
              <BpkText
                textStyle={TEXT_STYLES.subheading}
                tagName="p"
                className={STYLES.ExploreOtherOptions__searchTitle}
                color={TEXT_COLORS.textPrimary}
              >
                {translate('Explore_label_Could_not_find_right_hotel')}
              </BpkText>
              <SearchControls
                stay={stay}
                destination={destination}
                destinationLabel={translate(
                  'SearchControls_label_whereDoYouWantToStay',
                )}
                className={STYLES.ExploreOtherOptions__searchControls}
                arrangeInline={!isMobile}
                onSubmit={onSubmit}
                lightLabel={false}
                layout={isMobile ? LAYOUT.HORIZONTAL : LAYOUT.EXPANDABLE}
                masonry={!isMobile}
                hideLabel={isMobile}
              />
            </div>
          ) : null}
        </div>
      )}
    </BpkBreakpoint>
  );
};

export default withUserContext(
  withConfiguration(withI18n(ExploreOtherOptions)),
);
